import IdentificationTypesSelect from '@/components/common/input/identification-types-select/IdentificationTypesSelect';
import { Button } from '@/components/ui/button';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import useMixPanel from '@/hooks/useMixPanel';
import { useRootStore } from '@/providers/root-store-provider';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AuthorizedToPickUpForm: React.FC<{
  form: UseFormReturn<any, any, undefined>;
  formField: 'authorizedToPickUp';
  onSave: () => Promise<void>;
}> = ({ form, formField, onSave }) => {
  const Mixpanel = useMixPanel();
  const { t } = useTranslation(['newBooking', 'common']);

  const cleanConsumers = useRootStore((store) => store.cleanConsumers);
  const loadStepServicesData = useRootStore(
    (store) => store.loadStepServicesData
  );

  const handleValidate = () => {
    onSave();
    const data = form.getValues();
    cleanConsumers('user');
    loadStepServicesData(data.user);
  };

  return (
    <div
      className="border border-primary p-6 rounded-md flex flex-col gap-8 mb-3"
      key={`participant-participant`}
    >
      <FormField
        control={form.control}
        name={`${formField}.firstName`}
        render={({ field }) => {
          return (
            <FormItem>
              <FormLabel>{t('stepParticipants.form.firstName')}</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  onClick={() =>
                    Mixpanel.track('press user name input', {
                      screen: 'New Booking',
                      organization: 'Viento en popa'
                    })
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <FormField
        control={form.control}
        name={`${formField}.lastName`}
        render={({ field }) => {
          return (
            <FormItem>
              <FormLabel>{t('stepParticipants.form.lastName')}</FormLabel>
              <FormControl>
                <Input
                  onClick={() =>
                    Mixpanel.track('press lastName input', {
                      screen: 'New Booking',
                      organization: 'Viento en popa'
                    })
                  }
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <FormField
        control={form.control}
        name={`${formField}.phone`}
        render={({ field }) => {
          return (
            <FormItem>
              <FormLabel>{t('phone')}</FormLabel>
              <FormControl>
                <Input
                  onClick={() =>
                    Mixpanel.track('press user phone input', {
                      screen: 'New Booking',
                      organization: 'Viento en popa'
                    })
                  }
                  type="tel"
                  {...field}
                  placeholder={t('common:placeholder.phone')}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <FormField
        control={form.control}
        name={`${formField}.identification.type`}
        render={({ field }) => {
          return (
            <FormItem>
              <IdentificationTypesSelect
                defaultValue={field?.value}
                onValueChange={(value) => {
                  Mixpanel.track('press user id input', {
                    screen: 'New Booking',
                    organization: 'Viento en popa'
                  });
                  field.onChange(value);
                }}
                field={field}
              />
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <FormField
        control={form.control}
        name={`${formField}.identification.number`}
        render={({ field }) => {
          return (
            <FormItem>
              <FormLabel>
                {t('stepParticipants.form.identificationNumber')}
              </FormLabel>
              <FormControl>
                <Input
                  onClick={() =>
                    Mixpanel.track('press participants id number input', {
                      screen: 'New Booking',
                      organization: 'Viento en popa'
                    })
                  }
                  placeholder={t('stepParticipants.form.id')}
                  {...field}
                  value={field?.value || ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <Button type="button" onClick={handleValidate}>
        {t('common:validate')}
      </Button>
    </div>
  );
};

export default AuthorizedToPickUpForm;
